"use client"

import { Feedback } from "src/components/common/Feedback"
import { notFoundText } from "src/components/common/notFoundText"
import { routes } from "src/config/routes"
import { AppLocale } from "src/localization/localization"
import { localizeText } from "src/localization/utils"

export type NotFoundProps = {
  locale: AppLocale
}

export const NotFound = () => {
  const T = localizeText(notFoundText)

  return (
    <Feedback title={T.notFoundTitle} description={T.notFoundDescription} linkHref={routes.home} linkText={T.goHome} />
  )
}
